export function formatTypesName(path: string) {
  const parts = path.split("/");
  const lastPart = parts[parts.length - 1];
  return lastPart
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
